export default function Hero() {
  return (
    <section className="relative w-full">
      <div className="w-full overflow-hidden">
        <img
          src="/banner-hero.PNG"
          alt="Baños Run 2026 - Campeonato Nacional de Carreras de Calle"
          className="block w-full h-auto"
        />
      </div>

      {/* Quick info bar */}
      <div className="w-full px-4 md:px-8 lg:px-12 py-4 md:py-6">
        <div className="bg-white rounded-2xl md:rounded-3xl p-4 md:p-6 grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4 text-center">
          <div className="flex flex-col items-center justify-center gap-1 bg-background-50 md:bg-transparent rounded-xl p-2 md:p-0">
            <i className="ri-calendar-line text-primary-500 text-lg" />
            <span className="text-xs md:text-sm font-semibold text-foreground-700">Sáb. 18 Jul 2026</span>
          </div>
          <div className="flex flex-col items-center justify-center gap-1 bg-background-50 md:bg-transparent rounded-xl p-2 md:p-0">
            <i className="ri-time-line text-primary-500 text-lg" />
            <span className="text-xs md:text-sm font-semibold text-foreground-700">07:00</span>
          </div>
          <div className="flex flex-col items-center justify-center gap-1 bg-background-50 md:bg-transparent rounded-xl p-2 md:p-0">
            <i className="ri-map-pin-line text-primary-500 text-lg" />
            <span className="text-xs md:text-sm font-semibold text-foreground-700">Parque Montalvo, Baños</span>
          </div>
          <div className="flex flex-col items-center justify-center gap-1 bg-background-50 md:bg-transparent rounded-xl p-2 md:p-0">
            <i className="ri-route-line text-primary-500 text-lg" />
            <span className="text-xs md:text-sm font-semibold text-foreground-700">21K / 5K / Milla</span>
          </div>
          <div className="col-span-2 md:col-span-1 flex flex-col items-center justify-center gap-1 bg-background-50 md:bg-transparent rounded-xl p-2 md:p-0">
            <i className="ri-wallet-3-line text-primary-500 text-lg" />
            <span className="text-xs md:text-sm font-semibold text-primary-500">$20</span>
          </div>
        </div>
      </div>
    </section>
  );
}